export default {
  state: {
    title: '般芸智通',
    subTitle: '客户交互系统',
    welcomeInfo: '欢迎使用般芸智通客户系统'
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/projectInfo.js